import styled from 'styled-components'

export const DescriptionContainer = styled.div`
  & > h5 {
    font-size: 0.875em;
    color: #6c757d;
  }
`
export const StyledLicenseItem = styled.h6`
  display: list-item;
  margin-left : 1em;
  font-size: 0.875em;
  list-style-type: square;
  list-style-position: inside;
  color: #1f1f1f;
`

